import React, { useEffect, useState } from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { doService } from "../../../services/ServiceHelper";
import { getSchoolActivities, getTeacherActivities } from "../../../services/ActivityService";
import { getUserPriority } from "../../../services/UserService";

function MyActivitySelector({
  school,
  jwt,
  onChange,
  showLabel = true,
  selectLabel = "-- ALL ACTIVITIES --",
}) {
  const [_activities, setActivities] = useState([]);
  const [_selectedActivityEid, setSelectedActivityEid] = React.useState("XX");

  useEffect(() => {
    initActivities();
  }, []);

  const initActivities = () => {
    const priority = getUserPriority(jwt);

    if (priority === 800) {
      doService(getSchoolActivities(school, jwt), (result) => {
        setActivities(result.data);
      });
    } else {
      doService(getTeacherActivities(school, jwt), (result) => {
        setActivities(result.data);
      });
    }
  };

  const handleChangeActivity = (event) => {
    setSelectedActivityEid(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <>
      {showLabel && <InputLabel>Activity *</InputLabel>}

      <Select
        fullWidth
        size="small"
        onChange={handleChangeActivity}
        value={_selectedActivityEid}
      >
        <MenuItem key="XX" value="XX">
          {selectLabel}
        </MenuItem>
        {_activities.map((activity) => (
          <MenuItem key={activity.eid} value={activity.eid}>
            {getUserPriority(jwt) === 800 ? `${activity.last_name} - ${activity.name}` : activity.name }
          </MenuItem>
        ))}
      </Select>
    </>
  );
}

export default MyActivitySelector;
